import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Icon } from "@iconify/react";
import SearchOutlined from "@mui/icons-material/SearchOutlined";
import "./Campaign.css";
import AssignmentDetails from "./AssignmentDetails";
import CampaignDetails from "./CampaignDetails";
import Loader from "../Components/Loader";
// import useWindowDimensions from "../Hooks/useWindowDimensions";
import { setMakeCall } from "../Store/Actions/CallAction";

import {
  checkCampaignAutoDial,
  getAssignmentAutoDial,
  getCampaignList,
} from "../Store/Actions/OutboundAction";

import {
  SET_AUTO_DIAL,
  SET_AUTO_DIAL_CAMPAIGN,
  SET_DIAL_MODE,
  SET_LAST_ASSIGNMENTID,
  SET_AGENT_SELECTED_ASSIGNMENT,
} from "../Store/Types/AgentTypes";

import { SET_NEXT_ASSIGNMENT } from "../Store/Types/CallTypes";
import { SET_CURRENT_ASSIGNMENT_ID } from "../Store/Types/OutboundTypes";

export default function Campaign({ GenerateNonPopUpFiles, changePage }) {
  const { stateCall, ACWMode, ACWDuration } = useSelector(
    (state) => state.call
  );

  const [searchValue, setSearchValue] = useState("");
  const [campaignList, setCampaignList] = useState([]);
  const [filteredCampaignList, setFilteredCampaignList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const {
    isInAutoDial,
    lastAssignmentID,
    goToNextAssignment,
    callScheduleAssignmentID,
    autoDialCampaign,
    isAutoDialPaused,
    agentSelectedAssignment,
  } = useSelector((state) => state.agent);

  const [selectedCampaign, setSelectedCampaign] = useState(
    stateCall.CampaignID ? stateCall.CampaignID : null
  );

  const [selectedAssignment, setSelectedAssignment] = useState(
    stateCall.AssignmentID
      ? stateCall.AssignmentID
      : agentSelectedAssignment
      ? agentSelectedAssignment
      : null
  );

  const [isAutoDialEnabled, setIsAutoDialEnabled] = useState(false);
  const dispatch = useDispatch();
  const { CurrentState, myInfo } = useSelector((state) => state.auth);
  //const { width } = useWindowDimensions();

  useEffect(() => {
    setIsLoading(true);
    getCampaignList({
      loginid: myInfo.user.AgentID,
      clientid: myInfo.user.ClientID,
      source: 1, // Centerix code
    })
      .then((response) => {
        if (response.status) {
          console.log("campaignList: ", response.data);
          setCampaignList(response.data);
          setFilteredCampaignList(response.data);
          setIsLoading(false);
        } else {
          console.log("error", response.error);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.log("err", err);
        setIsLoading(false);
      });
  }, []);

  // Check campaign auto dial
  useEffect(() => {
    if (
      (selectedCampaign || autoDialCampaign.CampaignID) &&
      !isAutoDialPaused
    ) {
      checkCampaignAutoDial({
        loginID: myInfo.user.AgentID,

        CampaignID: selectedCampaign
          ? selectedCampaign.CampaignID
          : autoDialCampaign.CampaignID,

        Source: "centerix",
      })
        .then((response) => {
          process.env.NODE_ENV === "development" &&
            console.log("Auto dial: ", response.data.dialmode);

          setIsAutoDialEnabled(response.data.dialmode);

          if (response.data.dialmode) {
            getAssignment();
          }
        })
        .catch((err) => console.log("err", err));
    }
  }, [selectedCampaign]);

  useEffect(() => {
    if (isAutoDialEnabled && !isAutoDialPaused) {
      (selectedCampaign || autoDialCampaign.CampaignID) && getAssignment();
    }
  }, [goToNextAssignment]);

  // To reset selected campaign after outbound transfer. Only runs when not in autodial
  useEffect(() => {
    if (!isAutoDialEnabled && Object.keys(stateCall).length === 0) {
      setSelectedCampaign(null);
    }
  }, [stateCall]);

  // Show assignment from call schedule
  useEffect(() => {
    callScheduleAssignmentID && setSelectedAssignment(callScheduleAssignmentID);
  }, [callScheduleAssignmentID]);

  // Get assignment auto dial
  const getAssignment = () => {
    process.env.NODE_ENV === "development" &&
      console.log("selected campaign", selectedCampaign);

    getAssignmentAutoDial({
      agentid: myInfo.user.AgentID,
      // teamid: null,

      campaignid: autoDialCampaign.CampaignID
        ? autoDialCampaign.CampaignID
        : selectedCampaign.CampaignID,

      assignmentid: lastAssignmentID ? lastAssignmentID : 0, // set to 0 if there is no previous assignmentID

      datafilterid:
        autoDialCampaign.DataFilterID || autoDialCampaign.DataFilterID === 0
          ? autoDialCampaign.DataFilterID
          : selectedCampaign.DataFilterID,

      source: 1, // default 1
    })
      .then((response) => {
        if (response.data.phoneno[0].length) {
          process.env.NODE_ENV === "development" &&
            console.log("Next assignment: ", response.data.assignmentid);

          dispatch({
            type: SET_DIAL_MODE,
            payload: "progressive",
          });

          dispatch({ type: SET_AUTO_DIAL, payload: true });
          dispatch({ type: SET_NEXT_ASSIGNMENT, payload: true });

          dispatch({
            type: SET_LAST_ASSIGNMENTID,
            payload: response.data.assignmentid,
          });

          !autoDialCampaign.CampaignID &&
            dispatch({
              type: SET_AUTO_DIAL_CAMPAIGN,
              payload: selectedCampaign,
            });

          dispatch({
            type: SET_CURRENT_ASSIGNMENT_ID,
            payload: { assignmentID: response.data.assignmentid },
          });

          setSelectedAssignment(response.data.assignmentid);

          let formattedPhoneNumber =
            response.data.phoneno[0][0].Address.startsWith("62")
              ? "0" + response.data.phoneno[0][0].Address.slice(2)
              : response.data.phoneno[0][0].Address;

          dispatch(
            setMakeCall({
              phoneNo:
                (selectedCampaign.DialPrefix ?? "") + formattedPhoneNumber,

              // Set to READY on continue autodial. Otherwise get current agent status
              agentStatus: autoDialCampaign.CampaignID ? "READY" : CurrentState,
              goToACW: true,
              contactID: response.data.contactid,

              campaignID: autoDialCampaign.CampaignID
                ? autoDialCampaign.CampaignID
                : selectedCampaign.CampaignID,

              phoneTypeID: response.data.phoneno[0][0].AddressTypeID,

              ACWMode: autoDialCampaign.ACWMode
                ? autoDialCampaign.ACWMode
                : selectedCampaign.ACWMode,
              ACWDuration: autoDialCampaign.ACWDuration
                ? autoDialCampaign.ACWDuration
                : selectedCampaign.ACWDuration,
            })
          );
        } else {
          // When there are no more assignments, exit auto dial
          dispatch({ type: SET_AUTO_DIAL, payload: false });

          dispatch({
            type: SET_LAST_ASSIGNMENTID,
            payload: null,
          });

          dispatch({
            type: SET_AUTO_DIAL_CAMPAIGN,
            payload: {},
          });

          toast.info("Autodial has stopped. Please check assignment data", {
            autoClose: 3000,
          });
        }
      })
      .catch((err) => {
        console.log("err", err);

        // When there are errors, exit auto dial
        dispatch({ type: SET_AUTO_DIAL, payload: false });

        dispatch({
          type: SET_LAST_ASSIGNMENTID,
          payload: null,
        });

        dispatch({
          type: SET_AUTO_DIAL_CAMPAIGN,
          payload: {},
        });
      });
  };

  return (
    <div className="campaign">
      <div className="list_header">
        <div className="list_headerLeft">
          {(selectedAssignment || selectedCampaign || stateCall.ContactID) && (
            <Icon
              icon="material-symbols:arrow-back-ios-new-rounded"
              width="32"
              height="32"
              onClick={() => {
                // Disable when in auto dial
                if (!isInAutoDial) {
                  if (selectedAssignment || stateCall.ContactID) {
                    setSelectedAssignment(null);
                  } else {
                    setSelectedCampaign(null);
                  }
                }

                // Reset selected field assignment
                dispatch({
                  type: SET_AGENT_SELECTED_ASSIGNMENT,
                  payload: null,
                });
              }}
            />
          )}

          <div className="campaign-name">
            <h1>Campaign</h1>

            {(selectedAssignment ||
              selectedCampaign ||
              stateCall.ContactID) && <h2>{selectedCampaign?.CampaignName}</h2>}
          </div>
        </div>
      </div>

      {/* {width <= 1200 ? null : ( */}
      <div className="containerCampaign">
        {selectedAssignment || stateCall.ContactID ? (
          <AssignmentDetails
            assignmentID={selectedAssignment}
            setSelectedAssignment={setSelectedAssignment}
            GenerateNonPopUpFiles={GenerateNonPopUpFiles}
            acwMode={selectedCampaign ? selectedCampaign.ACWMode : ACWMode}
            acwDuration={
              selectedCampaign ? selectedCampaign.ACWDuration : ACWDuration
            }
            changePage={changePage}
          />
        ) : selectedCampaign ? (
          <CampaignDetails
            setSelectedAssignment={setSelectedAssignment}
            campaignID={selectedCampaign.CampaignID}
          />
        ) : (
          <>
            <div className="container_Header">
              <div className="campaign_search">
                <div className="search-container">
                  <SearchOutlined className="icon" />

                  <input
                    type="search"
                    className="search"
                    placeholder="Search..."
                    value={searchValue}
                    onChange={(e) => {
                      setSearchValue(e.target.value);

                      setFilteredCampaignList(
                        campaignList.filter((campaign) =>
                          campaign.CampaignName.toLowerCase().includes(
                            e.target.value
                          )
                        )
                      );
                    }}
                    onInput={(e) => {
                      if (e.target.value.length === 0) {
                        setFilteredCampaignList(campaignList);
                      }
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        setFilteredCampaignList(
                          campaignList.filter((campaign) =>
                            campaign.CampaignName.toLowerCase().includes(
                              searchValue
                            )
                          )
                        );
                      }
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="container_Body">
              {isLoading ? (
                <Loader />
              ) : (
                <>
                  <section className="list-campaign-group">
                    <header>
                      <p>Campaign Name</p>

                      <div className="totals">
                        <p>Total Data</p>
                        <p>Total Call</p>
                        <p>Total Not Called</p>
                      </div>
                    </header>

                    {filteredCampaignList?.length === 0 ? (
                      <p className="no-campaign">No Campaign Found</p>
                    ) : (
                      filteredCampaignList.map((campaign, index) => {
                        let collapsed = false;

                        return (
                          <div
                            className={`list-campaign-group-item ${
                              collapsed ? "collapsed" : ""
                            }`}
                            key={index}
                            onClick={() => setSelectedCampaign(campaign)}
                          >
                            <p>{campaign.CampaignName}</p>

                            {/* <Icon
                                className="collapse-button"
                                icon={`icon-park:${collapsed ? "up" : "down"}`}
                                width="20"
                                height="20"
                                onClick={() => (collapsed = !collapsed)}
                              /> */}

                            {/* <div className="list-campaign-item">
                                {campaign.campaignList.map((campaign) => (
                                  <div
                                    className="campaign-item"
                                    onClick={() => setSelectedCampaign(true)}
                                  >
                                    <p>{campaign.name}</p>

                                    <div className="totals">
                                      <p>{campaign.totalCall}</p>
                                      <p>{campaign.totalData}</p>
                                      <p>{campaign.totalNotCalled}</p>
                                    </div>
                                  </div>
                                ))}
                              </div> */}

                            <div className="totals">
                              <p>{campaign.TotalData}</p>
                              <p>{campaign.Called}</p>
                              <p>{campaign.NotCalled}</p>
                            </div>
                          </div>
                        );
                      })
                    )}
                  </section>
                </>
              )}
            </div>
          </>
        )}
      </div>
      {/* )} */}
    </div>
  );
}
